export default {
      id: "list-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#list",
      toString: function () {
        return this.url;
      }
    }